import React from 'react';
import nigeria from '../../../../../assets/img/icons/country/nigeria.png';
import useExpiredCustomers from '../../../../../hooks/shared/customers/useExpiredCustomers';

const ExpiredNigeriaCustomers = () => {
  const {
    state: { nigeriaExpired },
  } = useExpiredCustomers();

  return (
    <div className="col-lg col-md col-sm">
      <div className="boxes">
        <div className="text-center">
          <div className="text-center mt-3">
            <img src={nigeria} alt="Nigeria" width="40px" height="30px" />
          </div>
          <div className="count">{nigeriaExpired}</div>
          <h3 className="color-two">Nigeria Expired</h3>
        </div>
      </div>
    </div>
  );
};

export default ExpiredNigeriaCustomers;
